import { makeSvgImage } from '@/components/SvgImage/index.ts';

export const CupIcon = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="#FFDFA2"
      d="M13.035 1.184c0-.654.53-1.184 1.186-1.184h16.592c.655 0 1.185.529 1.185 1.183v12.328c0 5.1-4.368 9.008-9.481 9.008-5.114 0-9.483-3.907-9.482-9.008V1.184Z"
    />
    <path
      stroke="#031839"
      strokeWidth="2"
      d="M7 4.685c0-.102.083-.185.185-.185h15.63c.105 0 .185.083.185.182V17.3c0 4.66-3.702 8.2-8 8.2s-8-3.54-8-8.2V4.685Z"
    />
    <circle cx="26" cy="12.5" r="3" stroke="#031839" strokeWidth="2" />
    <circle cx="4" cy="12.5" r="3" stroke="#031839" strokeWidth="2" />
    <path fill="#031839" d="M14 24.5h2v5h-2z" />
    <rect
      width="2"
      height="16"
      x="7"
      y="31.5"
      fill="#031839"
      rx="1"
      transform="rotate(-90 7 31.5)"
    />
    <path stroke="#031839" strokeLinecap="round" strokeWidth="2" d="M20.148 8.297v7" />
  </svg>,
);
